import { LANG_COOKIE, type Locale } from "./config";

/**
 * Grava a escolha de idioma por 1 ano. O servidor (.htaccess) lê este cookie
 * e o respeita por cima do idioma do navegador nas próximas visitas.
 */
export function saveLanguagePreference(locale: Locale) {
  document.cookie = `${LANG_COOKIE}=${locale}; path=/; max-age=31536000; samesite=lax`;
}
